var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item" }, [
    _c(
      "div",
      {
        staticClass: "question flex flex-align-center flex-space-between",
        on: { click: _vm.clickQuestion }
      },
      [
        _c("div", { staticClass: "flex" }, [
          _c("img", {
            staticClass: "img",
            attrs: {
              alt: "",
              src: require("@/views/serverQa/components/img/Frame2757@2x.png")
            }
          }),
          _c("div", { staticClass: "text" }, [
            _vm._v(" " + _vm._s(_vm.data.q) + " ")
          ])
        ]),
        !_vm.showAnswer
          ? _c("img", {
              staticClass: "button",
              attrs: {
                alt: "",
                src: require("@/views/serverQa/components/img/down.png")
              }
            })
          : _c("img", {
              staticClass: "button",
              attrs: {
                alt: "",
                src: require("@/views/serverQa/components/img/up.png")
              }
            })
      ]
    ),
    _vm.showAnswer
      ? _c("div", { staticClass: "answer" }, [
          _c("div", { staticClass: "flex" }, [
            _c("img", {
              staticClass: "img",
              attrs: {
                alt: "",
                src: require("@/views/serverQa/components/img/Frame2758@2x.png")
              }
            }),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.data.a) + " ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }